import { useEffect } from 'react';

import { LIGHTWEIGHT_NAVIGATION_ITEMS } from 'bundles/degree-description/utils/utils';

const useNavIntersectionObserver = (setActiveTab: (navId: string) => void) => {
  useEffect(() => {
    const handleObserverUpdates = (entries: IntersectionObserverEntry[]) => {
      entries.forEach((entry) => {
        const { target, isIntersecting } = entry;
        if (isIntersecting) {
          setActiveTab(target.getAttribute('id') || '');
          if (target.getAttribute('id') === 'overview') {
            history.replaceState({}, '', location.pathname);
          } else {
            history.pushState(null, '', `#${target.getAttribute('id')}`);
          }
        }
      });
    };

    const callback: IntersectionObserverCallback = (entries) => handleObserverUpdates(entries);

    const observer = new IntersectionObserver(callback, {
      rootMargin: '-25% 0px -70% 0px',
    });

    const idList = LIGHTWEIGHT_NAVIGATION_ITEMS.map((item) => item.id);
    const pageSections = Array.from(document.querySelectorAll('div')).filter((div) => idList.includes(div.id));

    pageSections.forEach((element) => observer.observe(element));

    return () => observer.disconnect();
  }, [setActiveTab]);
};

export default useNavIntersectionObserver;
